import { moneyFormater } from 'utils/common';

export const parsDescriptionBilling = data => {
  const dataPlan = data.find(item => item.entity_type === 'plan');
  let plan = '';
  if (dataPlan) {
    plan = dataPlan.description.split(' -')[0].split(' #')[0];
  }
  let otherPlan = '';
  if (data.find(item => item.entity_type !== 'plan')) {
    data.forEach(item => {
      if (item.entity_type !== 'plan' && item.amount > 0) {
        let bigLater = item.description.split(' -')[0].split(' #')[0];
        // let bigLater = "";       //commented because if we need only first letters wariant not approved
        // item.description
        //   .split(" -")[0]
        //   .split(" ")
        //   .map(i => (bigLater += i[0]));
        otherPlan += `${item.quantity} ${bigLater},`;
      }
    });
  }
  if (plan && otherPlan) {
    return `${plan}, (${otherPlan.slice(0, -1)})`;
  } else if (plan) {
    return `${plan}`;
  } else if (otherPlan) {
    return `(${otherPlan.slice(0, -1)})`;
  }

  /*
   * Fell through every branch: no plan line, and no other line with a positive
   * amount. Returning nothing crashed the table, because BillingTable reads
   * `.length` off the result to decide whether to wrap it in a tooltip. The old
   * `total > 0` filter kept those invoices off screen, so removing the filter is
   * what made this reachable (P81-133660). 'NA' matches how the rest of the
   * billing helpers report a value they cannot build.
   */
  return 'NA';
};

/**
 * Formats an invoice total, which arrives from Chargebee in cents. Two cases the
 * old `total > 0` filter used to hide and that are now displayed:
 * - a null total, which the API maps to the string 'NA'
 * - a credit note, whose total is negative. moneyFormater takes the absolute
 *   value, so the sign has to be put back or a credit reads as a charge.
 */
export const formatInvoiceTotal = total => {
  // Checked before the cast: Number(null) is 0, and reporting a missing total
  // as $0 on a money column is worse than saying nothing.
  if (total === null || total === undefined || total === '') {
    return 'NA';
  }
  const amount = Number(total);

  if (!Number.isFinite(amount)) {
    return 'NA';
  }
  const formatted = moneyFormater(Math.abs(amount) / 100);

  return amount < 0 ? `-${formatted}` : formatted;
};

export const getBillingList = (
  invoices,
  direction,
  fieldName,
  currentPage,
  itemsPerPage
) => {
  let filterInvoice = [];

  invoices.sort((a, b) => {
    if (a[fieldName] > b[fieldName]) {
      return 1 * direction;
    }
    if (a[fieldName] < b[fieldName]) {
      return -1 * direction;
    }
    return 0;
  });

  invoices.forEach((e, index) => {
    if (
      index >= itemsPerPage * (currentPage - 1) &&
      index <= itemsPerPage * (currentPage - 1) + itemsPerPage - 1
    ) {
      filterInvoice.push(e);
    }
  });

  let newList = {
    page: currentPage,
    invoices: filterInvoice.length > 0 ? filterInvoice : null,
    size: invoices.length,
    totalPages: invoices.length / itemsPerPage
  };
  return newList;
};

export const displayPaymentMethods = array => {
  return array
    .map(paymentMethod => {
      if (paymentMethod === 'bank_transfer') {
        return 'bank';
      } else if (paymentMethod === 'paypal_express_checkout') {
        return 'paypal';
      } else {
        return paymentMethod;
      }
    })
    .join(', ');
};
